import React from "react";

//UI Material
import { Card, Divider, Grid, Stack } from "@mui/material";

//Material Icons
import { CalendarMonth } from "@mui/icons-material";

//Helpers
import {
  typographyForCustomizedFontSize,
  typographyForMainTitles,
  typographyForText,
} from "../../Helpers/typography";
import { selectMonth } from "../../Helpers/date";
import { evstations } from "../../Helpers/productSelector";

export default function ProductionSummaryInfo({ data = [] }) {
  // ==========> Component Functions <==========
  //Function to get the quantity of produced products of the day
  const getProducedOfTheDay = () => {
    let produced = { stations: 0, others: 0 };

    for (const order of data) {
      for (const product of order.productsStatus) {
        if (
          product.status === "FINISHED" &&
          new Date(product.finishedAt).getDate() === new Date().getDate() &&
          new Date(product.finishedAt).getMonth() === new Date().getMonth()
        ) {
          if (evstations.includes(order.productName)) {
            if (order.productName === "Estación Tipo Wallbox doble") {
              produced.stations += 2;
            } else {
              produced.stations++;
            }
          } else {
            produced.others++;
          }
        }
      }
    }

    return produced;
  };

  // ==========> Component <==========
  return (
    <Card
      raised
      sx={{
        height: "100%",
        borderLeft: `8px solid #003C3C`,
      }}
    >
      <Grid
        container
        sx={{ padding: "15px" }}
        spacing={1}
        alignItems="center"
        justifyContent="center"
      >
        <Grid item xs={6}>
          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={1}
          >
            <CalendarMonth />

            {typographyForMainTitles(new Date().getDate())}
            {typographyForText(selectMonth())}
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack direction="row" spacing={1}>
            <Divider orientation="vertical" flexItem />
            <Stack>
              <Stack direction="row" spacing={1} alignItems="center">
                {typographyForText(getProducedOfTheDay().stations, "bold")}
                {typographyForCustomizedFontSize("estaciones de carga", "11px")}
              </Stack>
              <Stack direction="row" spacing={1} alignItems="center">
                {typographyForText(getProducedOfTheDay().others, "bold")}
                {typographyForCustomizedFontSize("accesorios y otros", "11px")}
              </Stack>
            </Stack>
          </Stack>
        </Grid>
      </Grid>
    </Card>
  );
}
